
<div class="add-auction-fees-card">
  <form [formGroup]="addAuctionFeesForm"  name="addAuctionFeesForm" 
    (ngSubmit)="submitAddAuctionFeesForm()" class="add-auction-fees-card">
      <div class="form-group">
          <div class="ui-grid-row form-field-label">
              <div class="ui-grid-col-12">
              <label for="ClientId">Unique Client ID <span class="custom-required">*</span></label>
              </div>
          </div>
          <div class="ui-grid-row form-field">
              <div class="ui-grid-col-12 vert-center"> 
                  <p-dropdown #selectState  [options]="clientId" 
                      [(ngModel)]="selectedClientId"
                      formControlName="ClientId" 
                      [placeholder]="'Select One'" 
                      styleClass="add-bid-dropdown"
                      filter="true" 
                      filterBy="label,value">                        
                  </p-dropdown>
              </div>
          </div>

          <div class="ui-grid-row form-field-label">
              <div class="ui-grid-col-12">
              <label for="LoanType">Loan Type <span class="custom-required">*</span></label>
              </div>
          </div>
          <div class="ui-grid-row form-field">
              <div class="ui-grid-col-12 vert-center">
                  <p-dropdown #selectState  [options]="loanType"
                    [(ngModel)]="selectedLoantype" 
                    formControlName="LoanType" 
                    [placeholder]="'Select One'" 
                    styleClass="add-bid-dropdown"
                    filter="true" 
                    filterBy="label,value">                        
                  </p-dropdown>
                  <!-- <span *ngIf="county.touched && county.length == 0" class="custom-error">Please select state and then select trustee.</span> -->
              </div>                
          </div>

          <div class="ui-grid-row form-field-label">
            <div class="ui-grid-col-12">
              <label for="TypeOfSale">Type of Sale</label>
            </div>
          </div>
          <div class="ui-grid-row form-field">
            <div class="ui-grid-col-12 vert-center">
              <p-dropdown #selectState  [options]="typeOfSale"
                [(ngModel)]="selectedTypeOfSale"
                formControlName="TypeOfSale" 
                [placeholder]="'Select One'" 
                styleClass="add-bid-dropdown"
                filter="true" 
                filterBy="label,value">                        
              </p-dropdown>
              <!-- <span *ngIf="county.touched && county.length == 0" class="custom-error">Please select state and then select trustee.</span> -->
            </div> 
          </div>

          <div class="ui-grid-row form-field-label">
            <div class="ui-grid-col-12">
              <label for="FeeType">Fee Type <span class="custom-required">*</span></label>
            </div>
          </div>
          <div class="ui-grid-row form-field">
              <div class="ui-grid-col-12 vert-center">
                <p-dropdown #selectState  [options]="feeType" 
                  formControlName="FeeType" 
                  [placeholder]="'Select One'" 
                  styleClass="add-bid-dropdown"
                  (onChange)="formatType($event)"
                  filter="true" 
                  filterBy="label,value">                        
                </p-dropdown>
              </div>                
          </div>

          <div class="ui-grid-row form-field-label">
            <div class="ui-grid-col-12">
              <label for="FeeAmount">Fee Amount <span class="custom-required">*</span></label>
            </div>
          </div>
          <div class="ui-grid-row form-field">
              <div class="ui-grid-col-12 vert-center">
                <input type="text" pInputText  
                  placeholder="Fee Amount" 
                  formControlName="FeeAmount" style="width:200px"/><span style="font-size: 14px;">{{formatTypevalue}}</span>
              </div>
              <div *ngIf="feeAmountControl.touched && addAuctionFeesForm.get('FeeAmount').errors" style="color: red">
                Enter a valid number
              </div>                
          </div>

          <div class="add-bid-button-block">
              <button pButton type="button" 
                  label="Cancel" 
                  class="ui-button-secondary add-bid-button" 
                  (click)="hideAddAuctionFeesForm()">
              </button>
              <button pButton type="submit" 
                  label="{{processing ? 'Saving..' : 'Add Foreclosure Auction Location'}}" 
                  class="add-bid-button" 
                  [disabled]="addAuctionFeesForm.invalid">
              </button>
          </div>
      </div>
  </form>    
</div><br/>